import { CorpusManagerWrapper } from "@/components/corpus-manager/corpus-manager-wrapper";

const CorpusManager = () => {
  return (
    <div className="h-full flex flex-col bg-background p-6 text-text-500">
      <div className="flex-1">
        <CorpusManagerWrapper />
      </div>
    </div>
  );
};

export default CorpusManager;
